import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll() {
  useEffect(() => {
    const reduce = window
      .matchMedia("(prefers-reduced-motion: reduce)")
      .matches;
    if (reduce) return undefined;

    const lenis = new Lenis({ duration: 1.05, smoothWheel: true });
    document.documentElement.classList.add("lenis-active");

    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);

    const onClick = (event) => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const hash = link.getAttribute("href");
      event.preventDefault();
      if (hash === "#" || hash === "#top") {
        lenis.scrollTo(0);
        history.replaceState(null, "", "#top");
        return;
      }
      const target = document.querySelector(hash);
      if (!target) return;
      lenis.scrollTo(target, { offset: -92 });
      history.replaceState(null, "", hash);
    };

    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(frame);
      document.removeEventListener("click", onClick);
      document.documentElement.classList.remove("lenis-active");
      lenis.destroy();
    };
  }, []);

  return null;
}
